import { render } from "./FullCalendar.vue?vue&type=template&id=24283b4e"
import script from "./FullCalendar.vue?vue&type=script&lang=js"
export * from "./FullCalendar.vue?vue&type=script&lang=js"

import "./FullCalendar.vue?vue&type=style&index=0&id=24283b4e&lang=css"

import exportComponent from "/codebuild/output/src911820074/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__